import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import type { DivisionOrderLineItemDetailResponse } from './types';

const useDivisionOrderLineItemAtom = (divisionOrderId: string, id: string) =>
  useMemo(
    () =>
      createResourceAtom<DivisionOrderLineItemDetailResponse>(
        `/division_orders/${divisionOrderId}/line_items/${id}`
      ),
    [divisionOrderId, id]
  );

export { useDivisionOrderLineItemAtom };
